<template>
  <v-card>
    <v-card-title class="text-h5">
      Supprimer le monitor "{{ name }}" ?
    </v-card-title>
    <v-card-text>
      Cette action est irréversible. Êtes-vous sûr de vouloir supprimer ce monitor d'URL ?
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="$emit('openDialog', false)">
        Annuler
      </v-btn>
      <v-btn 
        color="error" 
        text 
        @click="deleteMonitor" 
        :loading="deleting"
        :disabled="deleting"
      >
        Supprimer
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  name: "UrlMonitorDelConfirmation",
  props: {
    dialogOpen: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  methods: {
    async deleteMonitor() {
      this.deleting = true;
      try {
        await this.$store.dispatch("webPerf/deleteUrlMonitor", this.id);
        this.$store.dispatch("alerts/addAlert", {
          message: `Monitor "${this.name}" supprimé avec succès`,
          type: "success",
        });
        this.$emit("openDialog", false);
      } catch (error) {
        console.error("Error deleting monitor:", error);
        this.$store.dispatch("alerts/addAlert", {
          message: "Erreur lors de la suppression du monitor",
          type: "error",
        });
      } finally {
        this.deleting = false;
      }
    },
  },
};
</script>